import React, { useRef, useState } from 'react';
import styles from './Chatbot.module.scss';
import ChatBody from './ChatBody';
import ChatFooter from './ChatFooter';
import { ReactComponent as ChatResizeIcon } from '../assets/svgs/resize-icon-top-left.svg';

interface ChatWindowProps {
    setIsChatVisible: React.Dispatch<React.SetStateAction<boolean>>;
}

const DesktopChat: React.FC<ChatWindowProps> = ({ setIsChatVisible }) => {
    const [chatWindowSize, setChatWindowSize] = useState({ width: 350, height: 550 });
    const resizableHandleRef = useRef<HTMLDivElement | null>(null);

    const handleMouseDown = (e: React.MouseEvent<HTMLDivElement> | React.TouchEvent<HTMLDivElement>) => {
        const startX = 'touches' in e ? e.touches[0].clientX : e.clientX;
        const startY = 'touches' in e ? e.touches[0].clientY : e.clientY;
        const startWidth = chatWindowSize.width;
        const startHeight = chatWindowSize.height;

        document.body.classList.add(styles.noSelect);

        const handleMouseMove = (e: MouseEvent | TouchEvent) => {
            const clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
            const clientY = 'touches' in e ? e.touches[0].clientY : e.clientY;
            const maxWidthInPercentage = 0.5;
            const maxHeightInPercentage = 0.8;
            const newWidth = Math.min(startWidth - (clientX - startX), window.innerWidth * maxWidthInPercentage);
            const newHeight = Math.min(startHeight - (clientY - startY), window.innerHeight * maxHeightInPercentage);
            setChatWindowSize({ width: newWidth, height: newHeight });
        };

        const handleMouseUp = () => {
            document.body.classList.remove(styles.noSelect);
            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('mouseup', handleMouseUp);
            document.removeEventListener('touchmove', handleMouseMove);
            document.removeEventListener('touchend', handleMouseUp);
        };

        document.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('mouseup', handleMouseUp);
        document.addEventListener('touchmove', handleMouseMove);
        document.addEventListener('touchend', handleMouseUp);
    };

    return (
        <div className={styles.chatWindowDesktop} style={{ width: chatWindowSize.width, height: chatWindowSize.height }}>
            <div ref={resizableHandleRef} className={styles.resizableHandle} onMouseDown={handleMouseDown} onTouchStart={handleMouseDown}>
                <ChatResizeIcon />
            </div>
            <div className={styles.chatHeader}>
                <h2 className={styles.chatHeaderTitle}>DEU·PA Assistent</h2>
                <button onClick={() => setIsChatVisible(false)} className={styles.closeButton}>
                    &#x2212;
                </button>
            </div>
            <ChatBody />
            <ChatFooter />
        </div>
    );
};

export default DesktopChat;
